function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ldOutLine"
}, /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 23.5,
  y1: 121.5,
  x2: 23.5,
  y2: 379.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 477.5,
  y1: 121.5,
  x2: 477.5,
  y2: 379.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 477.5,
  y1: 639,
  x2: 477.5,
  y2: 379
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 23.5,
  y1: 639,
  x2: 23.5,
  y2: 379
}), /*#__PURE__*/React.createElement("g", {
  id: "ldTri"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "ldT4",
  className: "st0",
  points: "250.5,22.5 23.5,22.5 23.5,121.5 112.5,46.5 47.5,46.5 47.5,71  "
}), /*#__PURE__*/React.createElement("polyline", {
  id: "ldT3",
  className: "st0",
  points: "250.5,22.5 477.5,22.5 477.5,121.5 388.5,46.5 453.5,46.5 453.5,71  "
}), /*#__PURE__*/React.createElement("polyline", {
  id: "ldT2",
  className: "st0",
  points: "250.5,738.5 477.5,738.5 477.5,639.5 388.5,714.5 453.5,714.5 453.5,690  "
}), /*#__PURE__*/React.createElement("polyline", {
  id: "ldT1",
  className: "st0",
  points: "250.5,738.5 23.5,738.5 23.5,639.5 112.5,714.5 47.5,714.5 47.5,690  "
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ldInnerLine"
}, /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 52.5,
  y1: 620,
  x2: 52.5,
  y2: 379.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 351,
  y1: 54.3,
  x2: 250.7,
  y2: 54.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 150,
  y1: 54.3,
  x2: 251,
  y2: 54.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 351,
  y1: 709.3,
  x2: 250.7,
  y2: 709.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 150,
  y1: 709.3,
  x2: 251,
  y2: 709.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 450.5,
  y1: 140.5,
  x2: 450.5,
  y2: 379.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 450.5,
  y1: 620,
  x2: 450.5,
  y2: 379.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 52.5,
  y1: 140.5,
  x2: 52.5,
  y2: 379.8
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "ldHand"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M249.2,505c30.1,0,66.6-4.5,76.7-38.3s-63.4-70.6-76.7-70.6s-86.7,36.7-76.7,70.6S219.1,505,249.2,505z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M175.2,327.2c-2.6-2.8-6.9-2.9-9.6-0.3c-9.4,9.3-28.7,30.7-28.9,49c-0.3,24.1,12.4,41.7,38.9,29.3 c25.4-11.9,26.7-31.7,23-44.1C195.6,351.2,182.9,335.7,175.2,327.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M326.3,327.2c2.6-2.8,6.9-2.9,9.6-0.3c9.4,9.3,28.7,30.7,28.9,49c0.3,24.1-12.4,41.7-38.9,29.3 c-25.4-11.9-26.7-31.7-23-44.1C305.9,351.2,318.5,335.7,326.3,327.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M249.2,361.2c68.7,0,19.8-95.2,0-95.2S180.5,361.2,249.2,361.2z"
}));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "loadingSvg",
    id: "\\u5716\\u5C64_2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 765",
    style: {
      enableBackground: "new 0 0 500 765"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.b0e71180.svg";
export { ForwardRef as ReactComponent };